module.exports = __webpack_public_path__ + "img/pop_bg.6d5f3221.png";